module.exports = __webpack_public_path__ + "media/images/games/k2gender/qimg1-bffa229a223e853995ee5465c826f406.png";